import { useState, useEffect } from 'react';
import { OrderDetails, OrderDetailsService } from '../../../../services';

export const useOrderDetails = () => {
  const [isFetchingOrderDetails, setIsFetchingOrderDetails] = useState(true);
  const [orderDetails, setOrderDetails] = useState({} as OrderDetails);
  const [orderDetailsError, setOrderDetailsError] = useState(undefined);

  useEffect(() => {
    const getOrderDetails = async () => {
      setIsFetchingOrderDetails(true);
      await OrderDetailsService.getOrderDetails()
        .then((details) => {
          setOrderDetails(details);
          setIsFetchingOrderDetails(false);
        })
        .catch(() => {
          setOrderDetailsError(OrderDetailsService.errorMessage);
          setIsFetchingOrderDetails(false);
        });
    };

    getOrderDetails();
  }, []);

  return {
    orderDetails,
    orderDetailsError,
    isFetchingOrderDetails,
  };
};
